import { ClipLoaderCommon, StyledBorderButton } from "@components";
import { breakpoint, theme } from "@utilities";
import styled from "styled-components";

interface BookNowButtonProps {
    handleClick: () => void;
    disabled?: boolean;
    isLoading: boolean;
}

const BookNowButton = ({ handleClick, disabled = false, isLoading }: BookNowButtonProps) => {
    return (
        <BorderButton
            onClick={handleClick}
            $textColor={theme.colors.button_text1}
            color="transparent"
            $borderColor={theme.colors.main}
            disabled={disabled}
            $borderRadius={theme.borderRadius.small}
            data-gtm-id="book-now"
        >
            {isLoading ? (
                <ClipLoaderCommon size={24} color={theme.colors.highlight} margin={0} />
            ) : (
                "Book Now"
            )}
        </BorderButton>
    );
};

export const BorderButton = styled(StyledBorderButton)`
    margin-top: 0px;
    width: 250px;
    height: 54px;
    ${breakpoint.breakOnlyMobile`
        margin-top: 0px;
        width : 100%;
    `};
`;

export default BookNowButton;
